// extracted by mini-css-extract-plugin
export default {"searchWrap":"SearchBar_searchWrap__bqoCs","searchInput":"SearchBar_searchInput__s5hv7","searchIcon":"SearchBar_searchIcon__D+2cJ","clearIcon":"SearchBar_clearIcon__9GHJe"};